import { render, staticRenderFns } from "./DebtHistoryTab.vue?vue&type=template&id=79e7be5e&scoped=true"
import script from "./DebtHistoryTab.vue?vue&type=script&lang=js"
export * from "./DebtHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./DebtHistoryTab.vue?vue&type=style&index=0&id=79e7be5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e7be5e",
  null
  
)

export default component.exports